import { Component, OnInit, EventEmitter, Input, Output, ViewChild, ElementRef, Renderer2, AfterViewInit, OnDestroy, HostListener } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, FormBuilder, FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { DmsService } from "src/app/dms/dms.service";
import { HttpErrorResponse } from '@angular/common/http';
import { KCC_App_SharepointClients } from "src/app/Models/azure";
import { KCC_App_UploadDocument, MetaDataFields, UploadConflictAction, UploadRequest } from 'src/app/Models/dmsModel';
import { ToastrService } from 'ngx-toastr';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { KC_MATERIAL_DATE_FORMATS } from 'src/app/Models/materialDatepickerConfig';
import { KcWarningPopupComponent } from '../../../shared/components/kc-warning-popup/kc-warning-popup.component';
import { DmsFolderLocationComponent } from '../../../dms/shared/dms-folder-location/dms-folder-location.component';
import { warningPopResponse, FileSizeLimit } from 'src/app/shared/app.constant';
import { catchError, map, takeUntil } from 'rxjs/operators';
import { XeroService } from 'src/app/settings/connections/xero/xero.service';
import { forkJoin, Observable, of, Subject } from 'rxjs';
import { DestroyableComponent } from 'src/app/shared/destroyable.component';
import { ActivatedRoute } from '@angular/router';
import { APP_CONSTANTS, DmsActionTypes } from 'src/app/Models/SharePointPracticeModel';
import { UserManagementService } from 'src/app/shared/userManagement.service';

@Component({
  selector: 'app-dms-upload-document',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, MatDatepickerModule, MatFormFieldModule, MatInputModule, MatIconModule, MatButtonModule, MatTooltipModule, NgSelectModule, NgMultiSelectDropDownModule, KcWarningPopupComponent, DmsFolderLocationComponent],
  templateUrl: './dms-upload-document.component.html',
  styleUrls: ['./dms-upload-document.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: KC_MATERIAL_DATE_FORMATS }, DatePipe],
})
export class DmsUploadDocumentComponent extends DestroyableComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('cancelUploaddocument') cancelUploaddocument: ElementRef;
  @ViewChild("folderLocationPopupRef") public folderLocationPopupRef: any;

  @Input() breadcrumbInfo!: {
    breadcrumbPath: string;
    rootFolderName: string;
    clientName: string;
    clientData?: any;
    rootFolderID?: string;  // UUID extracted from DocUrl for email attachments
  };
  @Input() SiteId: number = 0;
  @Input() SiteType: any = DmsActionTypes.Client;
  @Input() RootFolderID: string = "Root";
  @Input('uploadFileData') uploadFileData: any = null;
  @Input('canShowBrowseFiles') canShowBrowseFiles: boolean = true;
  @Input() canCallClientListAPI: boolean = true;

  @Output() resetForm: EventEmitter<any> = new EventEmitter<any>();
  @Output() outputParameter: EventEmitter<any> = new EventEmitter<any>();
  @Output() cancelClicked: EventEmitter<void> = new EventEmitter<void>();
  
  clients: any[];
  public UploadDocumentDataModal = new KCC_App_UploadDocument();
  metaDataFields: any[];
  dropdownData = [];
  selectedItems = [];
  selectedDate;
  NoUse: boolean = true;
  form: FormGroup;
  dropdownSettings1: { singleSelection: boolean; idField: string; textField: string; selectAllText: string; unSelectAllText: string; itemsShowLimit: number; allowSearchFilter: boolean; };
  files: { file: File, editableName: string }[] = [];
  fileCount: any;
  Clientgroup: any;
  Clientcode: any;
  ClientId: any;
  formValuesArray: { SharepointSiteMetadataId: number, Value: any }[] = [];
  maxDate: Date;
  warningPopupRes = warningPopResponse;
  fileSizeLimit = FileSizeLimit;
  uploadFolderpopupData: any = {};
  spFolderId: string = "";
  checkDisableButton: boolean;
  public fields: Object = { text: 'Name', value: 'ClientId' };
  private subscription = new Subject<void>();
  private timeoutId: any;
  private modalRef: BsModalRef;
  showFolderLocation: boolean = false;  // Show folder location for email attachments
  clientAsicData: any = {};
  canShowFolderLocationField: boolean = false;

  constructor(private _toastr: ToastrService, private _dmsService: DmsService,
    private fb: FormBuilder, public datepipe: DatePipe, private el: ElementRef, private renderer: Renderer2, private modalService: BsModalService, private xeroService: XeroService, private route: ActivatedRoute, private userManagementService: UserManagementService) {
    super();
  }

  ngOnInit(): void {
    this.createForm();
    this.initializeConstants();
    this.getRequiredDataBasedOnScreenType();
  }
 
  initializeConstants() {
    this.dropdownSettings1 = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };
    this.checkDisableButton = false;
    const canHideClientFields = (this.SiteType != DmsActionTypes.Client && this.SiteType != DmsActionTypes.globalUpload);
    this.NoUse = canHideClientFields;
    this.canShowFolderLocationField = this.SiteType == DmsActionTypes.globalUpload;
    this.clientAsicData = {};

    if(this.breadcrumbInfo?.clientData?.isPushFiles) {
      this.clientAsicData = {
        isPushFiles: true,
        isInitialTime: true,
        clientFoldersData: this.breadcrumbInfo?.clientData?.clientFoldersData || []
      };
      this.form.patchValue({
        folderLocation: this.breadcrumbInfo?.clientData?.breadcrumbPath || ''
      });
    }

    if (this.uploadFileData?.length) { this.setFilesData(); }
  }

  createForm() {
    this.form = this.fb.group({
      clientId: [''],
      clientGroup: [''],
      clientCode: [''],
      folderLocation: [''],
      fileUpload: ['', Validators.required],
    });
    this.updateClientValidators();
    this.updateFileUploadControl(this.canShowBrowseFiles);
    this.updateClientFieldsStateBasedOnSiteType();
  }

  getRequiredDataBasedOnScreenType() {
    const canCallClientData = ((this.SiteType === DmsActionTypes.globalUpload) || (this.SiteType === DmsActionTypes.Client));

    if (canCallClientData) { this.getClientData(); }
    
    if (this.breadcrumbInfo?.clientData && this.showFolderLocation) {
      this.setEmailPreviewAttachmentsRequiredData();
    }

    if (this.SiteType !== DmsActionTypes.globalUpload) {
      this.getMetaDataChild(this.SiteId);
      this.getMetaDataFields();
    }
  }

  setEmailPreviewAttachmentsRequiredData() {
    const { clientData } = this.breadcrumbInfo;
    const clientDataFromBreadcrumb = {
        clientId: clientData?.clientID ?? 0,
        clientCode: clientData?.clientCode ?? '',
        clientGroup: clientData?.clientGroupName ?? '',
        clientName: clientData?.clientName || this.breadcrumbInfo?.clientName,
        folderLocation: this.breadcrumbInfo?.breadcrumbPath ?? ''
      };
      
      if (clientDataFromBreadcrumb.clientId && clientDataFromBreadcrumb.clientName && (!this.clients || this.clients?.length === 0)) {
        this.clients = [{ ClientId: clientDataFromBreadcrumb.clientId, Name: clientDataFromBreadcrumb.clientName }];
      }
      
      // Patch form with extracted client data
      this.form.patchValue({
        clientId: clientDataFromBreadcrumb.clientId,
        clientCode: clientDataFromBreadcrumb.clientCode,
        clientGroup: clientDataFromBreadcrumb.clientGroup,
        folderLocation: clientDataFromBreadcrumb.folderLocation
      });
  }

  ngAfterViewInit(): void {
    this.disableDropdown();
    if (this.canShowBrowseFiles) {
      const fileUploadContainer = document.getElementById('fileUploadContainer');
      if (fileUploadContainer) {
        this.addEventListener(fileUploadContainer, 'dragover', this.handleDragOver.bind(this));
        this.addEventListener(fileUploadContainer, 'dragleave', this.handleDragLeave.bind(this));
        this.addEventListener(fileUploadContainer, 'drop', this.handleDrop.bind(this));
      }
    } else {
      // Handle the else case if needed.
    }
  }

  getClientData() {
    // For email attachments, use rootFolderID from breadcrumbInfo if available (extracted from DocUrl)
    const folderId = this.breadcrumbInfo?.rootFolderID || this.RootFolderID;
    
    if(this.canCallClientListAPI) {
      this.getClientList();
    } else {
      this.getClientsByClientID(folderId);
    }
  }

  getClientList() {
    this._dmsService.getClientList().pipe(takeUntil(this.subscription)).subscribe({
      next: (res: any) => {
        if (res) {
          this.clients = JSON.parse(res.httpResponse) as KCC_App_SharepointClients[];

          if (this.SiteId == undefined || this.SiteId == null) {
            this.SiteId = this.clients?.length ? this.clients[0]?.SiteId : this.SiteId;   // Set SiteId based on the first client's SiteId if available, otherwise keep existing SiteId
          }

          this.fields = { text: 'Name', value: 'ClientId' };
          // For email attachments, use rootFolderID from breadcrumbInfo if available (extracted from DocUrl)
          const folderId = this.breadcrumbInfo?.rootFolderID || this.RootFolderID;

          if (this.SiteType == DmsActionTypes.Client) {
            this.getClientsByClientID(folderId);
          }

          if(this.SiteType == DmsActionTypes.globalUpload && this.canCallClientListAPI) {
            this.loadClientDataFromRouteParams();
          }
        }
      },
      error: (error: any) => {
        this._toastr.error('Error fetching client list.');
      }
    });
  }

  getClientsByClientID(folderId: any) {
    this._dmsService.getClientsByClientID(folderId).pipe(takeUntil(this.subscription)).subscribe({
      next: (res: any) => {
        if (res) {
          if(!this.canCallClientListAPI) { this.setClientDropDownData(res); }

          this.form.patchValue({
            clientId: res.httpResponse.clientId ?? 0,
            clientGroup: res.httpResponse.clientGroup ?? "",
            clientCode: res.httpResponse.clientCode ?? "",
          });
        }
      },
      error: (error: any) => {
        this._toastr.error('Error fetching the client details.');
      }
    });
  }

  loadClientDataFromRouteParams(): void {
    const clientId = this.extractClientIdFromParams();
    const folderId = this.route?.snapshot?.queryParams?.folderId || null;
    const clientData = this.findClientById(clientId);
    this.uploadFolderpopupData.currentFolderLocationId = folderId;

    if (clientData?.ClientId) {
      this.patchFormWithClientData(clientData);
      this.loadClientFolderStructure(clientId, folderId);
    }
  }

  extractClientIdFromParams(): string | number {
    const routeParams = this.route.snapshot.queryParams;
    const clientId = (routeParams?.currentClientId ?? routeParams?.clientId ?? routeParams?.ClientId) || '0';
    return clientId;
  }

  findClientById(clientId: string | number): any {
    return this.clients?.find((client: any) => client?.ClientId == Number(clientId));
  }

  patchFormWithClientData(clientData: any): void {
    this.form.patchValue({
      clientId: clientData?.ClientId || 0,
      clientCode: clientData?.ClientCode || '',
      clientGroup: clientData?.ClientGroup || ''
    });
  }

  loadClientFolderStructure(clientId: string | number, folderId: string | null): void {
    if (folderId) {
      this.getFolderBreadCrumb(folderId);
    } else {
      this.getClientDocumentFolderLocation(clientId, folderId, true);
    }
  }

  getClientDocumentFolderLocation(clientId: any, folderId: string | null = null, canSetFolderLocation: boolean = false) {
    this.uploadFolderpopupData.currentFolderName = this.uploadFolderpopupData?.currentFolderName || 'Temporary';

    this._dmsService.GetClientDocumentFolderLocation(clientId, folderId).pipe(takeUntil(this.subscription)).subscribe({
      next: (res: any) => {
        if (res?.statusCode == 200) {
          const clientFoldersData = JSON.parse(res?.httpResponse || '[]');
          this.SiteId = clientFoldersData?.length ? clientFoldersData[0]?.SPSiteId : this.SiteId;
          const isUserMetadataConfigured = this.getUserMetadataConfigPermission();

          // Setup default Temporary folder as fallback
          const temporaryFolderData = clientFoldersData.find((folder: any) => folder.FName === 'Temporary');
          if (temporaryFolderData && temporaryFolderData?.ClientName) {
            this.uploadFolderpopupData = {
              ...this.uploadFolderpopupData,
              folderLoaction: `${temporaryFolderData?.ClientName}/${temporaryFolderData?.FName}`,
              clientId: temporaryFolderData?.ClientId || clientId,
              currentFolderLocationId: temporaryFolderData?.Id || null,
              currentFolderName: temporaryFolderData?.FName
            };
            this.uploadFolderpopupData.lastSelectedFolderName = null;
          }

          // For non-user-metadata scenarios, set folder location immediately
          if (!isUserMetadataConfigured && !canSetFolderLocation) {
            if (this.uploadFolderpopupData.folderLoaction) {
              this.form.controls["folderLocation"]?.setValue([this.uploadFolderpopupData.folderLoaction]);
            }
          }

          const clientFolderData = {
            canSetFolderLocation: canSetFolderLocation,
            clientFoldersData: clientFoldersData
          };
          this.getMetaDataChild(this.SiteId);
          this.getMetaDataFields(clientFolderData);
        } else {
          this._toastr.warning(res?.message || "Failed to fetch client folder location data.");
          this.resetFolderLocationData();
        }
      }, error: (error: any) => {
        let err: string = error?.error?.message || error?.error?.title || 'An error occurred while fetching client folder location data. Please try again.';
        this._toastr.error(err);
        this.resetFolderLocationData();
      }
    });
  }

  setFolderLocationValue(folderLocation: string = 'Temporary') {
    this.form.controls["folderLocation"]?.setValue([folderLocation]);
  }

  resetFolderLocationData() {
    this.form.controls["folderLocation"]?.setValue(null);
    this.uploadFolderpopupData.currentFolderLocationId = null;
    this.uploadFolderpopupData.currentFolderName = null;
    this.uploadFolderpopupData.folderLoaction = null;
    this.uploadFolderpopupData.lastSelectedFolderName = null;
  }

  getFolderBreadCrumb(folderId: any) {
    this._dmsService.GetBreadcrumbs(folderId).pipe(takeUntil(this.subscription)).subscribe({
      next: (res: any) => {
        if (res?.statusCode == 200) {
          const breadcrumbData = JSON.parse(res?.httpResponse || '[]');
          if (!breadcrumbData || breadcrumbData.length === 0) {
            this._toastr.warning("Invalid breadcrumb data received.");
            return;
          }
          
          this.SiteId = breadcrumbData?.length ? breadcrumbData[0]?.SiteId : this.SiteId;
          const parentId: string | null = breadcrumbData?.length ? breadcrumbData[0]?.ParentId : null;
          
          if((breadcrumbData?.length == 1) && (parentId == APP_CONSTANTS.EMPTY_GUID)) {
            // Single breadcrumb item at root - fetch folders directly
            // Pass canSetFolderLocation=true for potential user metadata folder setup
            this.getClientDocumentFolderLocation(this.form.value.clientId, folderId, true);
          } else {
            // Multiple breadcrumb items - set folder location from breadcrumb
            this.setFolderLocation(folderId, breadcrumbData);
            this.getMetaDataChild(this.SiteId);
            this.getMetaDataFields();
          }
        } else {
          this._toastr.warning(res?.message || "Failed to fetch folder breadcrumb data.");
        }
      }, error: (error: any) => {
        let err: string = error?.error?.message || error?.error?.title || 'An error occurred while fetching folder breadcrumb data. Please try again.';
        this._toastr.error(err);
      }
    });
  }

  setFolderLocation(folderId: string, breadcrumbData: any[] | null) {
    const { breadcrumb, clientName, rootFolderName } = this.buildBreadcrumbInfo(folderId?.toLowerCase(), breadcrumbData);
    const folderLocation = `${clientName} / ${breadcrumb}`;
    this.uploadFolderpopupData = {
      ...this.uploadFolderpopupData,
      folderLoaction: folderLocation,
      currentFolderLocationId: folderId,
      currentFolderName: rootFolderName
    };
    this.form?.controls["folderLocation"]?.setValue([folderLocation]);
  }

  buildBreadcrumbInfo(folderId: string, breadcrumbData: any[]): { breadcrumb: string, rootFolderName: string, clientName: string } {
    const folderMap = new Map<string, any>();
    breadcrumbData.forEach(folder => folderMap.set(folder.Id, folder));

    const segments: string[] = [];
    let rootFolderName = '';
    let clientName = '';

    // Traverse up from current folder
    let current = folderMap.get(folderId);
    let iterations = 0;
    const maxIterations = 1000; // Prevent infinite loops

    while (current && iterations < maxIterations) {
      iterations++;
      segments.unshift(current?.FolderName || '');

      const parent = folderMap.get(current?.ParentId);

      // If the parent is client-level (i.e., root node), set client name
      if (parent && parent?.ParentId == APP_CONSTANTS.EMPTY_GUID) {
        rootFolderName = current?.FolderName || '';
        clientName = parent?.FolderName || '';
        break;
      }

      // If the current folder is directly under the root
      if (current?.ParentId == APP_CONSTANTS.EMPTY_GUID) {
        clientName = current?.FolderName || '';
        break;
      }

      current = parent;
    }

    const breadcrumb = segments.join(' / ');

    return { breadcrumb, rootFolderName, clientName };
  }

  disableDropdown() {
    const dropdownContainer = this.el.nativeElement.querySelector('.form-select-filter-container');
    if (dropdownContainer) {
      this.renderer.addClass(dropdownContainer, 'disabled');
    }
  }

  updateFileUploadControl(canAddControlToFileUpload: boolean) {
    if (canAddControlToFileUpload) {
      !this.form.contains('fileUpload') ? this.form.addControl('fileUpload', this.fb.control('', Validators.required)) : '';
    } else {
      this.form.contains('fileUpload') ? this.form.removeControl('fileUpload') : '';
    }
  }

  updateClientFieldsStateBasedOnSiteType() {
    if((this.SiteType == DmsActionTypes.globalUpload) && this.canCallClientListAPI) {
      this.form.controls['clientId'].enable();
      this.form.controls['clientGroup'].disable();
      this.form.controls['clientCode'].disable();
    } else {
      this.form.controls['clientId'].disable();
      this.form.controls['clientGroup'].disable();
      this.form.controls['clientCode'].disable();
    }
  }

  updateClientValidators(): void {
    const clientIdControl = this.form.get('clientId');
    if (this.SiteType === DmsActionTypes.globalUpload) {
      clientIdControl?.setValidators([Validators.required]);
      this.form.addControl('folderLocation', this.fb.control('', Validators.required));
    } else {
      clientIdControl?.clearValidators();
    }
    clientIdControl?.updateValueAndValidity();
  }

  setFilesData() {
    this.files = this.uploadFileData.map((data: any) => {
      return {
        file: {
          name: data?.fileData.fileName || ''
        },
        editableName: this.getFileNameWithoutExtension(data?.fileData.fileName || '')
      };
    });
    // Update form control to mark files as provided
    this.form.get('fileUpload')?.setValue(this.files);
    
    // Show folder location input if this is an email attachment upload
    const isEmailAttachment = this.uploadFileData?.some((item: any) => item?.isEmailAttachment === true) || false;
    this.showFolderLocation = isEmailAttachment;

    this.canShowFolderLocationField = (this.showFolderLocation || this.clientAsicData?.isPushFiles) || false;
  }
  
  setClientDropDownData(res: any) {
    this.clients = [];
    const clientData = {
      Name: res?.httpResponse?.kcClientName || res?.httpResponse?.name,
      ClientId: res.httpResponse.clientId ?? 0
    }
    this.clients.push(clientData);
  }

  onClientChange(clientData: any, type: any) {
    if(this.SiteType == DmsActionTypes.globalUpload && this.canCallClientListAPI) {
      if(clientData) {
        this.form.patchValue({
          clientCode: clientData?.ClientCode || '',
          clientGroup: clientData?.ClientGroup || ''
        });
        // Pass canSetFolderLocation=true when user changes client selection for user metadata config
        this.getClientDocumentFolderLocation(clientData?.ClientId || 0, null, true);
      } else {
        this.onClientClear();
      }
    }
  }

  onClientClear() {
    this.resetFormControl('clientCode');
    this.resetFormControl('clientGroup');
    this.resetFormControl('folderLocation');
    this.uploadFolderpopupData = {};
  }

  resetFormControl(formControlName) {
    this.form.controls[formControlName]?.reset();
  }
 
  getMetaDataFields(folderData?: any) {
    let rootFolderName = this.breadcrumbInfo?.clientData ? this.breadcrumbInfo?.clientData?.rootFolderName : this.breadcrumbInfo?.rootFolderName;
    const isGlobalUpload = this.SiteType === DmsActionTypes.globalUpload;

    // For global upload, set the root folder name from the last or current selection in uploadFolderpopupData so metadata updates when the folder changes. For other screens, use breadcrumbInfo as it reflects the correct folder context.
    if(isGlobalUpload) {
      rootFolderName = this.uploadFolderpopupData?.currentFolderName || 'Temporary';
      const isRootFolderLocationNotChanged = this.uploadFolderpopupData?.currentFolderName === this.uploadFolderpopupData?.lastSelectedFolderName;

      if(isRootFolderLocationNotChanged) { return; }
    } else {
      rootFolderName = this.uploadFolderpopupData?.currentFolderName || rootFolderName || 'Temporary';
    }

    this._dmsService.getMetaDataFields(this.SiteId).pipe(takeUntil(this.subscription)).subscribe({
      next: (res: any) => {
        const isUserMetadataConfigEnabled = this.getUserMetadataConfigPermission();
        const metdataFields = JSON.parse(res.httpResponse) as MetaDataFields[];

        if(isUserMetadataConfigEnabled) {
          this.getUserConfiguredMetadataValues(metdataFields, rootFolderName, folderData);
        } else {
          this.handleMetadataFieldsMapping(metdataFields, rootFolderName);
        }     
      }, error: (error: any) => {
        this._toastr.error('Error fetching metadata fields.');
      }
    });
  }

  getUserMetadataConfigPermission(): boolean {
    return localStorage.getItem('userMetadataPermission') == "true";
  }

  handleMetadataFieldsMapping(metadataFieldsResponse: any, rootFolderName: string | null, folderData?: any) {
    this.metaDataFields = metadataFieldsResponse || [];
    this.metaDataFields.forEach(field => {
      let controlValue;
      if (field.DataType === 'CHOICE') {
        field.choiceArray = field.ChoiceValues ? field.ChoiceValues.split(',') : [];

        const matchedValue = field.IsDefaultRootFolder
          ? field.choiceArray.find(c => c?.trim()?.toLowerCase() === rootFolderName?.trim()?.toLowerCase())
          : null;

        controlValue = matchedValue ? [matchedValue] : [];
        if(matchedValue) {
          this.form.patchValue({ [field?.SharepointSiteMetadataId?.toString()]: controlValue });
        }
      } else {
        controlValue = null;
      }

      this.form.addControl(field.SharepointSiteMetadataId, this.fb.control(controlValue, field.Mandate ? Validators.required : null));
    });

    this.timeoutId = setTimeout(() => {
      this.metaDataFields
        .filter(f =>
          f.DataType === 'CHOICE' &&
          f.choiceArray?.length &&
          f.IsDefaultRootFolder
        )
        .forEach(f => {
          const matchedValue = f.choiceArray.find(
            c => c.trim().toLowerCase() === rootFolderName.trim().toLowerCase()
          );
          if (matchedValue) {
            this.onItemSelect(matchedValue, f);
          }
        });
    }, 10);

    const isGlobalUpload = this.SiteType === DmsActionTypes.globalUpload;
    if (isGlobalUpload) {
      this.uploadFolderpopupData.lastSelectedFolderName = this.uploadFolderpopupData.currentFolderName;
      // Ensure folder location is set - use current uploadFolderpopupData value
      if (this.uploadFolderpopupData.folderLoaction) {
        this.setFolderLocationValue(this.uploadFolderpopupData.folderLoaction);
      }
    }
  }

  getUserConfiguredMetadataValues(metadataFieldsResponse: any, rootFolderName: string | null, folderData?: any) {
    this.userManagementService.getUserMetadataConfig().pipe(takeUntil(this.subscription)).subscribe({
      next: (response: any) => {
        if(response?.length) {
          this.handleUseMetadataConfigResponse(response, metadataFieldsResponse, rootFolderName, folderData);
        } else {
          // No user configured metadata found - fallback to normal metadata
          this.handleMetadataFieldsMapping(metadataFieldsResponse, rootFolderName, folderData);
        }
      },
      error: (error: any) => {
        this._toastr.error('Failed to fetch user configured metadata.');
        // API failure - fallback to normal metadata but ensure folder location is set
        this.handleMetadataFieldsMapping(metadataFieldsResponse, rootFolderName, folderData);
      }
    });
  }

  handleUseMetadataConfigResponse(userConfiguredMetadata: any, metadataFieldsResponse: any, rootFolderName: string | null, folderData?: any) {
    if (!userConfiguredMetadata?.length || !metadataFieldsResponse?.length) {
      this.handleMetadataFieldsMapping(metadataFieldsResponse, rootFolderName, folderData);
      return;
    }

    const userConfigMap = this.createUserMetadataConfigMap(userConfiguredMetadata);
    const folderContext = this.resolveUserConfiguredFolderContext(
      userConfigMap.get(0),
      rootFolderName,
      folderData
    );

    this.metaDataFields = this.mergeMetadataFieldsWithUserConfig(metadataFieldsResponse, userConfigMap);
    this.addUserConfiguredMetadataControls(this.metaDataFields, folderContext.modifiedFolderName);
    this.setResolvedFolderLocation(folderContext.folderLocation);
    this.triggerSelectedMetadataDependencies();
    this.updateGlobalUploadSelectedFolderState();
  }

  private createUserMetadataConfigMap(userConfiguredMetadata: any[]): Map<number, any> {
    return userConfiguredMetadata.reduce((configMap: Map<number, any>, userConfig: any) => {
      configMap.set(userConfig?.metadataId, userConfig);
      return configMap;
    }, new Map<number, any>());
  }

  private resolveUserConfiguredFolderContext(userFolderConfig: any, rootFolderName: string | null, folderData?: any): { modifiedFolderName: string | null, folderLocation: string | null } {
    let modifiedFolderName = rootFolderName;
    let folderLocation: string | null = null;

    if (this.clientAsicData?.isPushFiles && this.clientAsicData?.isInitialTime) {
      modifiedFolderName = this.handleFoldersDataForAsicPushFiles(userFolderConfig, modifiedFolderName);
      this.clientAsicData.isInitialTime = false;
    }

    const canReturnModifiedValues = !userFolderConfig?.defaultValue || !folderData?.canSetFolderLocation || !folderData?.clientFoldersData?.length;
    if (canReturnModifiedValues) {
      return { modifiedFolderName, folderLocation };
    }

    const selectedFolder = this.findUserConfiguredFolder(folderData.clientFoldersData, userFolderConfig.defaultValue)
      || this.findTemporaryFolder(folderData.clientFoldersData);

    if (selectedFolder?.ClientName) {
      modifiedFolderName = selectedFolder.FName || modifiedFolderName;
      folderLocation = this.updateUploadFolderDataFromClientFolder(selectedFolder);
    } else if (!selectedFolder) {
      modifiedFolderName = 'Temporary';
    }

    return { modifiedFolderName, folderLocation };
  }

  private findUserConfiguredFolder(clientFoldersData: any[], defaultValue: string): any {
    return clientFoldersData?.find((folder: any) => folder?.FName?.trim() === defaultValue?.trim());
  }

  private findTemporaryFolder(clientFoldersData: any[]): any {
    return clientFoldersData?.find((folder: any) => folder?.FName === 'Temporary');
  }

  private updateUploadFolderDataFromClientFolder(folder: any): string {
    const folderLocation = `${folder?.ClientName}/${folder?.FName}`;
    this.uploadFolderpopupData = {
      ...this.uploadFolderpopupData,
      folderLoaction: folderLocation,
      clientId: folder?.ClientId,
      currentFolderLocationId: folder?.Id || null,
      currentFolderName: folder?.FName
    };

    return folderLocation;
  }

  private mergeMetadataFieldsWithUserConfig(metadataFieldsResponse: any[], userConfigMap: Map<number, any>): any[] {
    return (metadataFieldsResponse || []).map((baseField: any) => {
      const userConfig = userConfigMap.get(baseField?.SharepointSiteMetadataId);

      if (!userConfig?.defaultValue) {
        return baseField;
      }

      return {
        ...baseField,
        DefaultValue: userConfig?.defaultValue
      };
    });
  }

  private addUserConfiguredMetadataControls(metadataFields: any[], modifiedFolderName: string | null): void {
    metadataFields.forEach(field => {
      const controlValue = this.getUserConfiguredControlValue(field, modifiedFolderName);

      if (field?.DataType === 'CHOICE' && controlValue?.length > 0) {
        this.form.patchValue({ [field?.SharepointSiteMetadataId?.toString()]: controlValue });
      }

      this.form.addControl(field.SharepointSiteMetadataId, this.fb.control(controlValue, field.Mandate ? Validators.required : null));
    });
  }

  private getUserConfiguredControlValue(field: any, modifiedFolderName: string | null): any {
    switch (field.DataType) {
      case 'CHOICE':
        field.choiceArray = [];
        if (field?.ChoiceValues) {
          field.choiceArray = field?.ChoiceValues?.split(',');
        }
        return this.getChoiceControlValues(field, modifiedFolderName);
      case 'DATE':
        if (field?.DefaultValue) {
          return new Date(field?.DefaultValue);
        }
        return null;
      case 'YESNO':
        return this.getYesNoControlValue(field?.DefaultValue);
      case 'TEXT':
        return field?.DefaultValue || null;
      default:
        return null;
    }
  }

  private getYesNoControlValue(defaultValue: any): string | null {
    if (!defaultValue) { return null; }

    if (defaultValue === 'true' || defaultValue === true) { return 'true'; }

    return 'false';
  }

  private getChoiceControlValues(field: any, modifiedFolderName: string | null): string[] {
    if (modifiedFolderName && field?.IsDefaultRootFolder) {
      const folderChoice = this.findChoiceValue(field?.choiceArray, modifiedFolderName);

      if (folderChoice) { return [folderChoice]; }
    }

    return this.getDefaultChoiceValues(field.choiceArray, field.DefaultValue);
  }

  private getDefaultChoiceValues(choiceArray: string[], defaultValue: any): string[] {
    if (!defaultValue) { return []; }

    return this.normalizeDefaultValues(defaultValue)
      .map((value: string) => this.findChoiceValue(choiceArray, value))
      .filter(Boolean);
  }

  private normalizeDefaultValues(defaultValue: any): string[] {
    if (Array.isArray(defaultValue)) {
      return defaultValue.map((value: any) => value?.toString()?.trim());
    }

    let defaultValues = [defaultValue];
    if (typeof defaultValue === 'string') {
      defaultValues = defaultValue?.split(',');
    }

    return defaultValues?.map((value: any) => value?.toString()?.trim());
  }

  private findChoiceValue(choiceArray: string[], value: string): string | undefined {
    return choiceArray.find((choice: string) => choice?.trim()?.toLowerCase() === value?.trim()?.toLowerCase());
  }

  private setResolvedFolderLocation(folderLocation: string | null): void {
    const folderLocationToSet = folderLocation || this.uploadFolderpopupData.folderLoaction;

    if (folderLocationToSet) {
      this.setFolderLocationValue(folderLocationToSet);
    }
  }

  private triggerSelectedMetadataDependencies(): void {
    this.timeoutId = setTimeout(() => {
      this.metaDataFields
        .filter(field => field?.DataType === 'CHOICE')
        .forEach(field => {
          const selectedValues = this.form.get(field.SharepointSiteMetadataId?.toString())?.value;

          if (selectedValues?.length) {
            this.onItemSelect(selectedValues?.[0], field);
          }
        });
    }, 10);
  }

  private updateGlobalUploadSelectedFolderState(): void {
    if (this.SiteType === DmsActionTypes.globalUpload) {
      this.uploadFolderpopupData.lastSelectedFolderName = this.uploadFolderpopupData?.currentFolderName;
    }
  }

  metadataDependencyMappings: any = [];

  getMetaDataChild(siteId: number) {
    this._dmsService.getMetadataDependencyMappings(siteId).pipe(takeUntil(this.subscription)).subscribe({
      next: (res: any) => {
        this.metadataDependencyMappings = JSON.parse(res.httpResponse); // Save in component
      },
      error: (error: any) => {
        this._toastr.error('Error fetching metadata dependency mappings.');
      }
    });
  }

  handleFoldersDataForAsicPushFiles(userFolderConfig: any, rootFolderName: string): string {
    const userConfiguredFolderLocationValue = userFolderConfig?.defaultValue || rootFolderName;
    const userConfiguredFolderData = this.clientAsicData?.clientFoldersData?.find(folder => folder?.spFolderName === userConfiguredFolderLocationValue);
    const modifiedFolderName = userConfiguredFolderData?.spFolderName || rootFolderName;
    let folderLocation = '';

    if(userConfiguredFolderData?.id) {
      this.uploadFolderpopupData = {
        ...this.uploadFolderpopupData,
        folderLoaction: userConfiguredFolderData?.name + '/' + modifiedFolderName,
        clientId: userConfiguredFolderData?.clientId || this.ClientId,
        currentFolderLocationId: userConfiguredFolderData?.id || null,
        currentFolderName: modifiedFolderName
      }
      folderLocation = this.uploadFolderpopupData?.folderLoaction || '';
    } else {
      folderLocation = this.breadcrumbInfo?.clientData?.breadcrumbPath || '';
    }

    this.form.patchValue({ folderLocation });

    return modifiedFolderName || 'Temporary';
  }

  isFieldInvalid(field: string): boolean {
    const control = this.form.get(field);
    return control?.invalid && (control.dirty || control.touched);
  }

  clearDocumetlist(folderId) {
    this.resetForm.emit();
    this.outputParameter.emit(folderId);
  }

  onItemSelect(event: any, field: MetaDataFields) {
    this.updateFormValuesArray(field.SharepointSiteMetadataId, event);

    if (!this.metadataDependencyMappings || this.metadataDependencyMappings.length === 0) {
      return;
    }

    if (field.DataType === 'CHOICE') {
      const selectedValues = this.form.get(field.SharepointSiteMetadataId.toString())?.value || [];

      // Find all relevant child mappings based on all selected main values
      const matchedMappings = this.metadataDependencyMappings.filter(dep =>
        dep.ParentMetadataId === field.SharepointSiteMetadataId &&
        selectedValues.some(val => dep.ParentChoiceValue.trim().toLowerCase() === val.trim().toLowerCase())
      );

      if (matchedMappings.length === 0) {
        // Clear all relevant child fields if no mappings found
        const childFields = this.metaDataFields.filter(f =>
          this.metadataDependencyMappings.some(m =>
            m.ParentMetadataId === field.SharepointSiteMetadataId &&
            m.ChildMetadataId === f.SharepointSiteMetadataId
          )
        );

        childFields.forEach(child => {
          child.choiceArray = null;
          const control = this.form.get(child.SharepointSiteMetadataId.toString());
          if (control) {
            control.setValue(null);
          }
        });

        return;
      }

      // Group mappings by child metadata ID and collect unique child choices
      const childChoiceMap = new Map<number, Set<string>>();

      matchedMappings.forEach(dep => {
        const childId = dep.ChildMetadataId;
        const childValues = dep.ChildChoiceValue ? dep.ChildChoiceValue.split(',').map(v => v.trim()) : [];

        if (!childChoiceMap.has(childId)) {
          childChoiceMap.set(childId, new Set());
        }

        childValues.forEach(val => childChoiceMap.get(childId)!.add(val));
      });

      // Update child fields with combined child values
      childChoiceMap.forEach((choices, childId) => {
        const childField = this.metaDataFields.find(f => f.SharepointSiteMetadataId === childId);
        if (childField) {
          childField.choiceArray = Array.from(choices);
        }
      });
    }
  }


  onSelectAll(event: any, field: MetaDataFields) {
    this.updateFormValuesArray(field.SharepointSiteMetadataId, event);
  }

  onDeSelect(event: any, field: MetaDataFields) {
    this.updateFormValuesArray(field.SharepointSiteMetadataId, event, true);
    this.onItemSelect(event, field);
    this.updateChildChoices(field); // refresh child based on remaining parents
  }

  onItemDeSelectAll(field: MetaDataFields) {
    this.removeFormValuesArray(field.SharepointSiteMetadataId);
    this.clearAllChildChoices(field);
  }

  onDateChange(date: any, field: MetaDataFields) {
    this.updateFormValuesArray(field.SharepointSiteMetadataId, date);
  }

  onYesNoChange(event: any, field: MetaDataFields, value: string) {
    this.updateFormValuesArray(field.SharepointSiteMetadataId, value);
  }

  invalidFileNames: { [index: number]: string } = {};

  updateFileName(index, value) {
    // to change file name of the specific added file as editableName
    this.files[index].editableName = value;

    if (value.trim() === '') {
      this.invalidFileNames[index] = ' * ';
      this._toastr.warning(`File name cannot be empty.`);
    } else if (value.length > 400) {
      this.invalidFileNames[index] = ' * ';
      this._toastr.warning(`File name is too long.`);
    } else if (this._dmsService.FORBIDDEN_FILENAME_CHARS_REGEX_TEST.test(value)) {
      this.invalidFileNames[index] = ' * ';
      this._toastr.warning(this._dmsService.MSG_FORBIDDEN_FILENAME_CHARS_PATTERN);
    } else if (this._dmsService.RESERVED_FILE_NAMES_PATTERN.some(
      name => name.toLowerCase() === value.toLowerCase()
    )) {
      this.invalidFileNames[index] = ' * ';
      this._toastr.warning(this._dmsService.MSG_RESERVED_FILE_NAMES_PATTERN);
    } else {
      delete this.invalidFileNames[index]; // Valid input
    }
  }

  updateFormValuesArray(id: number, value: any, remove: boolean = false) {
    const index = this.formValuesArray.findIndex(item => item.SharepointSiteMetadataId === id);
    if (remove) {
      if (index !== -1) {
        this.formValuesArray.splice(index, 1);
      }
    } else {
      if (index !== -1) {
        this.formValuesArray[index].Value = value;
      } else {
        this.formValuesArray.push({ SharepointSiteMetadataId: id, Value: value });
      }
    }
  }

  removeFormValuesArray(id: number) {
    const index = this.formValuesArray.findIndex(item => item.SharepointSiteMetadataId === id);
    if (index !== -1) {
      this.formValuesArray.splice(index, 1);
    }
  }

  onFileSelected(event: any): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.handleFiles(input.files);
      this.checkDisableButton = false;
    }
  }

  deleteFile(index: number) {
    this.files.splice(index, 1);
    this.checkDisableButton = this.files?.length === 0;
    if (this.uploadFileData && this.uploadFileData?.length) {  // File deletion from uploadFileData
      this.uploadFileData = this.uploadFileData?.filter((fileData, ind) => (ind !== index));
    }
  }

  downloadDocument(data: any, fileIndex: number): Observable<any> {
    // Check if this is an email attachment (has content directly)
    if (data?.isEmailAttachment && data?.fileData?.content) {
      try {
        const fileExt = this.getExtension(data?.fileData?.fileName);
        const renamedFileName = this.files[fileIndex]?.editableName?.trim() != ""
          ? `${this.files[fileIndex]?.editableName?.trim()}.${fileExt}`
          : data?.fileData?.fileName;

        // Create File directly from email attachment content
        const file = new File(
          [data?.fileData?.content],
          renamedFileName,
          { type: data?.fileData?.mimeType || "application/octet-stream" }
        );
        return of(file);
      } catch (error) {
        this._toastr.error('Failed to process email attachment. Please try again.');
        return of(null);
      }
    }
    const payload = {
      documentId: data?.fileData?.documentId || '',
      connectionId: data?.fileData?.connectionId || '',
      fileName: data?.fileData?.fileName || '',
      connectionType: data.fileData?.connectionType || '',
      fileUrl: data.fileData?.fileLinks[0]?.href || ''
    };

    return this.xeroService.downloadNowInfinityDocument(payload).pipe(
      map((response: any) => {
        if (response) {
          const fileExt = this.getExtension(data?.fileData?.fileName);
          const renamedFileName = this.files[fileIndex]?.editableName?.trim() != "" ? `${this.files[fileIndex]?.editableName?.trim()}.${fileExt}` : data?.fileData?.fileName;
          return new File([response?.body], renamedFileName, { type: data?.fileData?.fileType || "application/pdf" });
        } else {
          this._toastr.error('Failed to push file. No documents found. Please try again.');
          return of(null);
        }
      }),
      catchError((error: any) => {
        this.handleDownloadError(error);
        return of(null);
      })
    );
  }

  handleDownloadError(error: any) {
    if (error?.error instanceof Blob) {
      const reader = new FileReader();
      reader.onload = () => {
        try {
          const errorData = JSON.parse(reader.result as string);
          this._toastr.error(errorData?.Message || errorData?.message || errorData?.title || 'Failed to push file. An error occurred while downloading the document. Please try again.');
        } catch (e) {
          this._toastr.error('Failed to push file. An error occurred while downloading the document. Please try again.');
        }
      };
      reader.readAsText(error?.error);
    } else {
      this._toastr.error(error?.error?.Message || error?.error?.message || error?.error?.title || 'Failed to push file. An error occurred while downloading the document. Please try again.');
    }
  }

  onSubmit() {
    if (!this.form.valid) {
      this.form.markAllAsTouched();
      return;
    }

    this.formValuesArray = [];

    const uniqueIds = new Set<number>();
    const excludedKeys = new Set(['fileUpload', 'clientId', 'clientGroup', 'clientCode', 'folderLocation']); // Add any other non-metadata fields form control keys here

    for (const key in this.form.value) {
      if (this.form.value.hasOwnProperty(key)) {
        if (!excludedKeys.has(key)) {
          const id = parseInt(key);
          const value = this.form.value[key];
          if (value !== null && value !== "") {
            if (!uniqueIds.has(id)) {
              uniqueIds.add(id);
              const fieldMeta = this.metaDataFields.find(field => field.SharepointSiteMetadataId === id);
              if (fieldMeta && fieldMeta.DataType === 'DATE') {
                const convertedDate = this.convertToDateFormat(this.datepipe.transform(value, 'dd/MM/yyyy'), "dynamic");
                this.formValuesArray.push({
                  SharepointSiteMetadataId: id,
                  Value: convertedDate
                });
              } else {
                this.formValuesArray.push({
                  SharepointSiteMetadataId: id,
                  Value: value
                });
              }
            }
          }
        }
      }
    }

    let metadataValues = this.formValuesArray
      .filter(item => {
        if (Array.isArray(item?.Value)) {
          return item?.Value?.length > 0;  // Keep only if array has length
        }
        return (item?.Value != null && item?.Value !== '');  // Keep if value exists and not empty string
      })
      .map(item => {
        if (Array.isArray(item?.Value)) {
          return {
            ...item,
            Value: item?.Value?.join(',')
          };
        }
        return item;
      });

    const metadataValuesString = JSON.stringify(metadataValues);

    let files: File[] = [];

    if (this.uploadFileData && this.uploadFileData?.length) {
      const downloadObservables = this.uploadFileData.map((file: any, index: number) => this.downloadDocument(file, index));

      forkJoin(downloadObservables)
        .pipe(takeUntil(this.subscription))
        .subscribe({
          next: (fileDataArray: (File | null)[]) => {
            const files: File[] = [];

            fileDataArray.forEach(fileData => {
              if (fileData) {
                files.push(fileData);
              }
            });

            if (files.length > 0) {
              this.checkDuplicateAndUpload(metadataValuesString, files);
            } else {
              this._toastr.error('Failed to push file. No documents were downloaded. Please try again.');
            }
          }
        });
    } else {
      const filesControlValue = this.form.get('fileUpload')?.value || [];
      files = filesControlValue.map((fileInfo: { file: File, editableName: string }) => {
        const fileExt = this.getExtensionFile(fileInfo.file.name);
        const renamedFileName = fileInfo.editableName?.trim() != "" ? `${fileInfo.editableName?.trim()}.${fileExt}` : fileInfo?.file?.name;
        return new File([fileInfo.file], renamedFileName, {
          type: fileInfo.file.type,
          lastModified: fileInfo.file.lastModified
        });
      });
      
      this.checkDuplicateAndUpload(metadataValuesString, files);
    }
  }

  processUpload(metadataValuesString: string, files: File[], conflictAction: UploadConflictAction): void {
    if (files.length > 0) {
      const fileSize = files.reduce((acc, file) => acc + file.size, 0);
      const maxSizeBytes = this.fileSizeLimit.Max * 1024 * 1024;
      if (fileSize > maxSizeBytes) {
        this.modalRef = this.modalService.show(KcWarningPopupComponent, {
          class: 'modal-dialog-centered',
          backdrop: 'static',
          initialState: {
            mainContent: `We are unable to save this file. The file size must be less than ${this.fileSizeLimit.Max} MB to save successfully.`,
            isSaveAndCloseReq: false,
            isYesReq: false,
            isNoReq: false,
            isOkReq: true,
            isConfirm: false,
            subContent: ''
          }
        });
        this.modalRef.content.event.subscribe(res => {

          if (res === this.warningPopupRes.OK) {
            this.modalRef?.hide();
          }
        })
        return;
      }
    }

    const clientId = (this.SiteType === DmsActionTypes.Client || this.SiteType === DmsActionTypes.globalUpload) ? this.form.get('clientId').value : 0;
    let folderId: string;
    
    if (this.showFolderLocation) {
      folderId = this.uploadFolderpopupData?.currentFolderLocationId || this.breadcrumbInfo?.rootFolderID || this.RootFolderID;
    } else if (this.SiteType === DmsActionTypes.globalUpload) {
      folderId = this.uploadFolderpopupData?.currentFolderLocationId || this.RootFolderID;
    } else {
      folderId = this.breadcrumbInfo?.rootFolderID || this.uploadFolderpopupData?.currentFolderLocationId || this.RootFolderID;
    }
    const request: UploadRequest = {
      metadataValues: metadataValuesString,
      files: files,
      clientId: clientId,
      folderId: folderId,
      siteId: this.SiteId, 
      contextType: 'Communication',
      conflictAction: conflictAction ?? UploadConflictAction.Ask
    };

    this._dmsService.uploadDocuments(request).pipe(takeUntil(this.subscription)).subscribe({
      next: (response: any) => {
        if (response.statusCode >= 200) {
          this._toastr.success(response.message);
          this.clearDocumetlist(response.httpResponse);
        }
      },
      error: (error: HttpErrorResponse) => this.handleError(error)
    });

  }

  private handleError(error: HttpErrorResponse): void {
    let errorMessage = 'An unexpected error occurred';
    if (error.error instanceof ErrorEvent) {
      errorMessage = `Error: ${error.error.message}`;
    } else {
      errorMessage = error.error.message || error.error.title || error.error.Message || error.message || errorMessage;

      switch (error.status) {
        case 400:
        case 401:
        case 404:
          this._toastr.error(errorMessage);
          break;
        case 413:
          this._toastr.error(errorMessage + ': ' + "Payload Too Large");
          break;
        default:
          this._toastr.error(errorMessage);
          break;
      }
    }
  }

  handleDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    const target = event.currentTarget as HTMLElement;
    target.classList.add('drag-over');
  }

  handleDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    const target = event.currentTarget as HTMLElement;
    target.classList.remove('drag-over');
  }

  handleDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    const target = event.currentTarget as HTMLElement;
    target.classList.remove('drag-over');

    if (event.dataTransfer?.files) {
      // Pass files directly as FileList without converting to array
      this.handleFiles(event.dataTransfer.files);  // FileList
    }
  }
  getFileNameWithoutExtension(fileName: string): string {
    return fileName.replace(/\.[^/.]+$/, ""); // Remove the extension
  }
  getExtension(filename: string): string | undefined {
    const match = filename.match(/\.([0-9a-z]+)(?:[\?#]|$)/i);
    return match ? match[1] : undefined;
  }

  getExtensionFile(filename: string): string {
    const lastDotIndex = filename.lastIndexOf('.');
    return lastDotIndex !== -1 ? filename.substring(lastDotIndex + 1) : '';
  }

  convertToDateFormat(dateString: string, type: string = "static"): string {
    const regex = /^(\d{2})[-\/](\d{2})[-\/](\d{4})$/;
    const match = dateString.match(regex);
    if (match && type === "static") {
      const day = match[1];
      const month = match[2];
      const year = match[3];
      return `${year}/${month}/${day}`;
    } else if (match && type === "dynamic") {
      const day = match[1];
      const month = match[2];
      const year = match[3];
      return `${year}/${month}/${day}`;
    }
    const date = new Date(dateString);
    if (!isNaN(date.getTime()) && type === "static") {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}/${month}/${day}`;
    } else if (type === "dynamic") {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}/${month}/${day}`;
    }
    return '';
  }

  onCancelClicked() {
    this.cancelClicked.emit(); // Emitting event when cancel button is clicked
    this.resetForm.emit();
  }

  getShortBreadcrumb(): string {
    if (!this.breadcrumbInfo) return '';

    const { clientName, breadcrumbPath, rootFolderName } = this.breadcrumbInfo;
    const fullBreadcrumb = `${clientName} / ${breadcrumbPath}`;
    const shortBreadcrumb = this._dmsService.getShortBreadcrumb(fullBreadcrumb, 3);

    if (shortBreadcrumb.length <= 64) {
      return shortBreadcrumb;
    }

    const lastPart = this._dmsService.getShortBreadcrumb(breadcrumbPath, 2);

    // Prevent duplication of root folder
    const finalBreadcrumb = lastPart.startsWith(rootFolderName)
      ? `... / ${lastPart}`
      : `${rootFolderName} / ... / ${lastPart}`;

    return finalBreadcrumb;
  }

  isDraggingOver = false;

  handleFiles(files: FileList): void {
    const existingFileNames = new Set(this.files.map(f => f.file.name + f.file.size));

    const maxLengthValidator = Validators.maxLength(500);
    const fileNameValidator = this._dmsService.fileNameValidator();
    const reservedFileNameValidator = this._dmsService.reservedFileNameValidator();

    for (let i = 0; i < files.length; i++) {
      const file = files.item(i);
      
      if (file && !existingFileNames.has(file.name + file.size)) {
        const nameControl = new FormControl(file.name, [maxLengthValidator, fileNameValidator, reservedFileNameValidator]);
        const errors = nameControl.errors;

        if (errors) {
          // Inform user about sanitization due to invalid characters
          const sanitizedName = this._dmsService.sanitizeFileName(file.name);
          this._toastr.info(`File "${file.name}" was sanitized to "${sanitizedName}".`);

          this.files.push({
            file,
            editableName: this.getFileNameWithoutExtension(sanitizedName)
          });
          existingFileNames.add(sanitizedName + file.size);
        } else {
          // No validation errors, use original name
          this.files.push({
            file,
            editableName: this.getFileNameWithoutExtension(file.name)
          });
          existingFileNames.add(file.name + file.size);
        }
      }
    }

    this.form.get('fileUpload')?.setValue(this.files);
  }

  hasInvalidFileNames(): boolean {
    return Object.keys(this.invalidFileNames).length > 0;
  }

  @HostListener('window:dragover', ['$event'])
  onDragOver(event: DragEvent) {
    event.preventDefault();
    this.isDraggingOver = true;
  }

  @HostListener('window:dragleave', ['$event'])
  onDragLeave(event: DragEvent) {
    event.preventDefault();
    this.isDraggingOver = false;
  }

  @HostListener('window:drop', ['$event'])
  onDrop(event: DragEvent) {
    event.preventDefault();
    this.isDraggingOver = false;
    if (event.dataTransfer && event.dataTransfer.files.length > 0) {
      this.handleFiles(event.dataTransfer.files);
    }
  }
  updateChildChoices(parentField: MetaDataFields) {
    if (!this.metadataDependencyMappings?.length) return;

    const selectedValues = this.form.get(parentField.SharepointSiteMetadataId.toString())?.value || [];

    // Find all mappings where ParentMetadataId matches
    const matchedMappings = this.metadataDependencyMappings.filter(
      dep =>
        dep.ParentMetadataId === parentField.SharepointSiteMetadataId &&
        selectedValues.includes(dep.ParentChoiceValue.trim())
    );

    // Map of ChildMetadataId → combined child values (from all selected parents)
    const childChoiceMap = new Map<number, Set<string>>();

    matchedMappings.forEach(dep => {
      const childId = dep.ChildMetadataId;
      const childValues = dep.ChildChoiceValue?.split(',').map(v => v.trim()) || [];
      if (!childChoiceMap.has(childId)) {
        childChoiceMap.set(childId, new Set());
      }
      childValues.forEach(val => childChoiceMap.get(childId)!.add(val));
    });

    // Update each child field dropdown and cleanup invalid selected values
    childChoiceMap.forEach((choices, childId) => {
      const childField = this.metaDataFields.find(f => f.SharepointSiteMetadataId === childId);
      if (!childField) return;

      // Update available dropdown options
      childField.choiceArray = Array.from(choices);

      // Clean existing selected values if any are no longer valid
      const control = this.form.get(childId.toString());
      if (control) {
        let currentValues = control.value || [];
        if (!Array.isArray(currentValues)) currentValues = [currentValues];

        const validValues = currentValues.filter((val: string) => choices.has(val));
        if (validValues.length !== currentValues.length) {
          control.setValue(validValues.length > 0 ? validValues : null);
        }
      }
    });
  }

  clearAllChildChoices(parentField: MetaDataFields, visited: Set<number> = new Set()) {
    if (!this.metadataDependencyMappings?.length) return;

    // Prevent recursion loops
    if (visited.has(parentField.SharepointSiteMetadataId)) return;
    visited.add(parentField.SharepointSiteMetadataId);

    const childMappings = this.metadataDependencyMappings.filter(
      dep => dep.ParentMetadataId === parentField.SharepointSiteMetadataId
    );

    childMappings.forEach(dep => {
      const childField = this.metaDataFields.find(f => f.SharepointSiteMetadataId === dep.ChildMetadataId);
      if (!childField) return;

      // Clear dropdown and value
      childField.choiceArray = null;
      const control = this.form.get(childField.SharepointSiteMetadataId.toString());
      if (control) control.setValue(null);
      this.removeFormValuesArray(childField.SharepointSiteMetadataId);

      // Recurse further down to grandchildren
      this.clearAllChildChoices(childField, visited);
    });
  }

  checkDuplicateAndUpload(metadataValues: string, files: File[]): void {
    if (!files || files.length === 0) return;

    const fileNames = files.map(f => f.name);

    let folderId: string;
    
    if (this.showFolderLocation) {
      folderId = this.uploadFolderpopupData?.currentFolderLocationId || this.breadcrumbInfo?.rootFolderID || this.RootFolderID;
    } else if (this.SiteType === DmsActionTypes.globalUpload) {
      folderId = this.uploadFolderpopupData?.currentFolderLocationId || this.RootFolderID;
    } else {
      folderId = this.breadcrumbInfo?.rootFolderID || this.uploadFolderpopupData?.currentFolderLocationId || this.RootFolderID;
    }

    this._dmsService.checkDuplicateFiles(folderId, fileNames).pipe(takeUntil(this.subscription)).subscribe({
      next: (result: any[]) => {
        const activeDuplicates = result?.filter(r => r.isDuplicate && !r.isDeleted) ?? [];

        if (activeDuplicates.length === 0) {
          this.processUpload(metadataValues, files, UploadConflictAction.Ask);
          return;
        }

        const duplicateNames = activeDuplicates.map(d => d.fileName);
        this.openDuplicatePopup(duplicateNames, metadataValues, files);
      },
      error: (error: any) => {
        const err = error?.error?.message || error?.error?.title || 'Error while checking duplicate files';
        this._toastr.error(err);
      }
    });
  }


  openDuplicatePopup(duplicateFileNames: string[], metadataValues: string, files: File[]): void {
    const maxPreview = 3;
    const previewFiles = duplicateFileNames.slice(0, maxPreview);
    const remainingCount = duplicateFileNames.length - previewFiles.length;

    let fileListHtml = previewFiles
      .map(name => `• ${name}`)
      .join('<br/>');

    if (remainingCount > 0) {
      fileListHtml += `<br/>…and ${remainingCount} more`;
    }

    this.modalRef = this.modalService.show(KcWarningPopupComponent, {
      class: 'modal-dialog-centered',
      backdrop: 'static',
      initialState: {
        mainContent: `
          <b>The following files (${duplicateFileNames.length}) already exist:</b><br/><br/>
          ${fileListHtml}<br/><br/>
          <b>What would you like to do with these files?</b>
        `,
        subContent: ``,
        isYesReq: true,
        isNoReq: true,
        isCancel: true, 
        yesText: 'Replace all',
        noText: 'Keep all'
      }
    });

    this.modalRef.content.event.subscribe(res => {

      if (res === this.warningPopupRes.YES) {
        this.processUpload(
          metadataValues,
          files,
          UploadConflictAction.Replace
        );
      }

      if (res === this.warningPopupRes.NO) {
        this.processUpload(
          metadataValues,
          files,
          UploadConflictAction.CreateNew
        );
      }

      if (res === this.warningPopupRes.CANCEL) {
        this.modalRef.hide();   // Just close, no upload
      }
    });
  }

  openFolderLocationPopup() {
    const clientId = this.form.controls["clientId"]?.value || "";
    if (clientId) {
      const previousFolderPopupData = this.uploadFolderpopupData;
      
      // For email preview: use folderIdFromDocUrl which we get in the  breadcrumbInfo.rootFolderID
      // For normal upload: use previously selected folder or null
      let initialFolderId: string;
      if(this.clientAsicData?.isPushFiles) {
        initialFolderId = previousFolderPopupData?.currentFolderLocationId || this.breadcrumbInfo?.rootFolderID || this.RootFolderID || null;
      } else {
        initialFolderId = this.breadcrumbInfo?.rootFolderID || previousFolderPopupData?.currentFolderLocationId || this.RootFolderID || null;
      }
      
      this.uploadFolderpopupData = {
        ...previousFolderPopupData,
        clientId: clientId,
        currentFolderLocationId: initialFolderId,
      }
      
      this.modalRef = this.modalService.show(this.folderLocationPopupRef, {
        class: `modal-dialog-centered cmn-modal-dsgn modal-lg`,
        backdrop: "static",
        keyboard: false
      });
    } else {
      this._toastr.error("Please select client name to locate folder.")
    }
  }

  hideFolderLocationPopUp() {
    this.modalRef.hide();
  }

  sendFolderLocation(folderLocation: any) {
    const location = folderLocation?.locationPath ?? "";
    this.form.controls["folderLocation"]?.setValue([location]);
    this.uploadFolderpopupData = {
      ...this.uploadFolderpopupData,
      folderLoaction: location,
      currentFolderLocationId: folderLocation?.locationFolderId ?? null,
      currentFolderName: folderLocation?.rootFolderName || null,
    };
    this.getMetaDataChild(this.SiteId);
    this.getMetaDataFields();
    this.hideFolderLocationPopUp();
  }

  ngOnDestroy(): void {
    this.subscription.next();
    this.subscription.complete();
    super.ngOnDestroy();
    // Prevent memory leaks if the component gets destroyed
    if (this.timeoutId) { clearTimeout(this.timeoutId); }
  }

}
